import { Edit } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';

export type RowActionsProps = {
  onRowClickHandler: (record: any) => void;
  record: any;
};

const RowActions = (props: RowActionsProps) => {
  const { record: params, onRowClickHandler } = props;
  return (
    <Box data-testid="row-actions">
      <IconButton
        onClick={() => {
          onRowClickHandler(params.row);
        }}
        color="primary"
        data-testid="row-edit-button"
        sx={{
          minWidth: {
            xs: '44px',
            sm: '40px',
          },
          minHeight: {
            xs: '44px',
            sm: '40px',
          },
          padding: {
            xs: '10px',
            sm: '8px',
          },
        }}
      >
        <Edit 
          color="primary" 
          sx={{
            fontSize: {
              xs: '1.25rem',
              sm: '1.2rem',
            },
          }}
        />
      </IconButton>
    </Box>
  );
};

export default RowActions;
